// material-ui
import { PaletteColorOptions } from '@mui/material/styles';

//project-import
import { ThemeMode } from 'config';

//assets
import { PalettesProps } from '@ant-design/colors';

// types
import { PaletteThemeProps } from 'types/theme';

// ==============================|| PRESET THEME - CLASSIC ||============================== //

export default function Classic(colors: PalettesProps, mode: ThemeMode): PaletteThemeProps {
  const { grey } = colors;
  const greyColors: PaletteColorOptions = {
    0: '#000000', // Black background
    50: '#1a1a1a',
    100: '#2d2d2d',
    200: '#404040',
    300: '#525252',
    400: '#666666',
    500: '#808080',
    600: '#999999',
    700: '#b3b3b3',
    800: '#cccccc',
    900: '#e6e6e6',
    A50: '#000000',
    A100: '#1a1a1a',
    A200: '#2d2d2d',
    A400: '#404040',
    A700: '#525252',
    A800: '#666666'
  };
  const contrastText = '#000000';

  // Classic theme colors - black background with golden orange accents
  let primaryColors = ['#1a1a1a', '#2d2d2d', '#404040', '#525252', '#666666', '#808080', '#999999', '#b3b3b3', '#cccccc', '#e6e6e6'];
  let errorColors = ['#ff8e8e', '#ff6b6b', '#ff5252', '#ff4040', '#ff2e2e']; // Brighter red colors like dark mode
  let warningColors = ['#4d4d1a', '#66661f', '#808024', '#999929', '#b3b32e'];
  let infoColors = ['#1a4d4d', '#1f6666', '#248080', '#299999', '#2eb3b3'];
  let successColors = ['#1a4d1a', '#1f661f', '#248024', '#299929', '#2eb32e'];

  // Classic theme specific colors
  const classicPrimary = '#FFD700'; // Gold
  const classicSecondary = '#cccccc';
  const classicBackground = '#000000';
  const classicPaper = '#1a1a1a';
  const classicText = '#FFD700'; // Gold text

  return {
    primary: {
      lighter: classicPrimary,
      100: classicPrimary,
      200: classicPrimary,
      light: classicPrimary,
      400: classicPrimary,
      main: classicPrimary,
      dark: classicPrimary,
      700: classicPrimary,
      darker: classicPrimary,
      900: classicPrimary,
      contrastText: '#000000'
    },
    secondary: {
      lighter: classicSecondary,
      100: classicSecondary,
      200: classicSecondary,
      light: classicSecondary,
      400: classicSecondary,
      main: classicSecondary,
      600: classicSecondary,
      dark: classicSecondary,
      800: classicSecondary,
      darker: classicSecondary,
      A100: classicSecondary,
      A200: classicSecondary,
      A300: classicSecondary,
      contrastText: '#000000'
    },
    error: {
      lighter: errorColors[0],
      light: errorColors[1],
      main: errorColors[2],
      dark: errorColors[3],
      darker: errorColors[4],
      contrastText
    },
    warning: {
      lighter: warningColors[0],
      light: warningColors[1],
      main: warningColors[2],
      dark: warningColors[3],
      darker: warningColors[4],
      contrastText: greyColors[100]
    },
    info: {
      lighter: infoColors[0],
      light: infoColors[1],
      main: infoColors[2],
      dark: infoColors[3],
      darker: infoColors[4],
      contrastText
    },
    success: {
      lighter: successColors[0],
      light: successColors[1],
      main: successColors[2],
      dark: successColors[3],
      darker: successColors[4],
      contrastText
    },
    grey: greyColors
  };
} 